import React from 'react';
// components
import LoadingView from 'refactored/ui/views/loadingView';

const LoadingPage = () => <LoadingView />;

export default LoadingPage;
